import React, { FC } from "react";
import Logo from "components/Logo/Logo";
import Navigation from "components/Navigation/Navigation";
import SearchDropdown from "./SearchDropdown";
import ButtonPrimary from "components/Button/ButtonPrimary";
import MenuBar from "components/MenuBar/MenuBar";
import DarkModeContainer from "containers/DarkModeContainer/DarkModeContainer";

import {injected} from "utils/connectors";
import { useWeb3React } from "@web3-react/core";

export interface MainNav1Props {
  isTop: boolean;
}

const MainNav1: FC<MainNav1Props> = ({ isTop }) => {
  const {active, account, library, connector, activate, deactivate} =  useWeb3React();
  const handleClickConnect = async () => {
    console.log("Hello");
    try {
      if(active == true) {
        await deactivate();
      }
      else {
        await activate(injected);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div
      className={`nc-MainNav1 relative z-10 ${
        isTop ? "onTop " : "notOnTop backdrop-filter"
      }`}
    >
      <div className="container py-5 relative flex justify-between items-center space-x-4 xl:space-x-8">
        <div className="flex justify-start flex-grow items-center space-x-4 sm:space-x-10 2xl:space-x-14">
          <Logo />
          <Navigation />
        </div>
        <div className="flex-shrink-0 flex items-center justify-end text-neutral-700 dark:text-neutral-100 space-x-1">
          <div className="hidden items-center xl:flex space-x-1">
            <DarkModeContainer />
            {/* <SearchDropdown /> */}
            <div className="px-1" />
            <ButtonPrimary onClick={handleClickConnect}>{active? `${account?.substring(0,4)}...${account?.substring(account.length-4,account.length)}`:"Connect"}</ButtonPrimary>
          </div>
          <div className="flex items-center xl:hidden">
            <MenuBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
